import { Directive, EventEmitter, OnInit, Output } from '@angular/core';
import { BHMetaModel, BaseDataModel, FormMetaModel, ResponseAndErrorModel, RouteMessage } from 'common/models/utilitymodels/base.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SystemService } from 'common/services/core_services/system.service';
import { HeadersList, ListModel, MinMaxFilter, QueryParams, paginationType } from '../../models/utilitymodels/list.model';
import { ListDataWidgetService } from '../../services/core_services/list.data.widget.service';
import { emailConstantRegex, formValidationCheck, NavigateRoutes, RequestType, StorageConstants } from 'common/constants/app.constant';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { SideMenuModel, TabInfoModel } from 'common/models/utilitymodels/menu.model';
import { BasePage } from './base.page';
@Directive()
export class BaseViewPage<T extends ListModel<BaseDataModel>, G extends BHMetaModel> extends BasePage implements OnInit {
    listpageData: T;
    listpageMeta: any;
    listQueryParams: QueryParams;
    listComponentData: any;
    initializedListForm: FormGroup = new FormGroup({});
    sideMenuItems = new SideMenuModel().sideMenuInfo;
    @Output() onChangePageNumber = new EventEmitter<{ type: paginationType; page: number; }>();
    constructor(protected activatedRoute: ActivatedRoute, protected widgetService: ListDataWidgetService<BaseDataModel, T>, protected systemService: SystemService, protected router: Router) {
        super(systemService);
    }

    ngOnInit(): void {
        this.listpageData = this.activatedRoute.snapshot.data['data']['data'];
        this.listpageMeta = this.activatedRoute.snapshot.data['data']['meta'];
        this.listComponentData = this.activatedRoute.snapshot.data['data']['componentData'];
        if (this.activatedRoute.snapshot.data['data']['componentData']?.actionType === RequestType.BACK) {
            this.activatedRoute.snapshot.data['data']['componentData'];
            this.listQueryParams = this.activatedRoute.snapshot.data['data']['queryParams'];
        } else {
            this.listQueryParams = new QueryParams();
            this.listQueryParams.currentPage = this.listComponentData.selectedPage;
            this.listQueryParams.filterFeilds = this.listComponentData.searchableFeilds;
            this.listQueryParams.recordPerPage = this.listComponentData.recordPerPage;
            this.listQueryParams.minMaxFilter = this.listComponentData.minMaxFilter;
            this.listQueryParams.apiParams = this.listComponentData.routeData.pageData;
        }

        console.log('.....>list', this);
    }

    generateForm(formData: any, fromMeta: any): FormGroup {
        const keyData = Object.keys(formData).filter((element: any) => element !== 'id');
        keyData.forEach((element: any) => {
            this.initializedListForm.addControl(element, new FormControl(formData[element]));
            this.addFieldValidation(element, fromMeta[element]);
        });
        return this.initializedListForm;
    }

    handleViewport(isInViewport: boolean) {
        if (isInViewport) {
            // Do something when the element is in the viewport
        } else {
            // Do something when the element is out of the viewport
        }
    }

    protected async prepareData(originalModel: any, listQueryParams: QueryParams): Promise<void> {
        this.widgetService
            .processGridData(new ResponseAndErrorModel(originalModel, []), listQueryParams)
            .then((data: any) => {
                this.listpageData = data;
            })
            .catch((e: any) => this.handleError(e, 'Base Veiw'));
    }

    async filterByMinMax(list: MinMaxFilter[]) {
        this.listQueryParams.minMaxFilter = list;
        this.processData(this.listpageData.listMaster, this.listQueryParams);
    }

    filterByValue(value: string) {
        this.listpageData.selectedPage = 1;
        this.listQueryParams.currentPage = this.listpageData.selectedPage;
        this.listQueryParams.filterValue = value;
        this.listComponentData.pageData.filterFeild = value;
        this.processData(this.listpageData.listMaster, this.listQueryParams);
    }

    async filterData(filter: string, headersList: HeadersList[]): Promise<void> {
        this.listpageData.selectedPage = 1;
        this.listQueryParams.currentPage = this.listpageData.selectedPage;
        this.listQueryParams.searchText = this.listpageData.searchText;
        const filterFeilds: string[] = [];
        headersList.forEach((header: HeadersList) => {
            if (header.isSerchable) {
                filterFeilds.push(header.keyName);
            }
        });
        this.listQueryParams.filterFeilds = filterFeilds;
        this.processData(this.listpageData.listMaster, this.listQueryParams);
    }

    processData(originalModel: any, qureyParams: any): void {
        void this.prepareData(originalModel, qureyParams);
    }

    scrollToTop() {
        const scrollEl = document.querySelector('.app-router-outlet');
        if (window.innerWidth >= 992) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            if (scrollEl !== null) {
                // scrollEl.scrollTo({ top: 0, behavior: 'smooth' });
                scrollEl.scroll(0, 0);
            }
        }
    }

    changePage(data: { type: paginationType; page: number; }): void {
        this.listQueryParams.paginationType = data.type;
        if (data.type === 'load more') {
            data.page++;
        } else {
            this.scrollToTop();
        }
        this.listpageData.selectedPage = data.page;
        this.listQueryParams.currentPage = data.page;

        this.processData(this.listpageData.listMaster, this.listQueryParams);
    }

    async sortData(sortFeildHeader: HeadersList, headerList: HeadersList[]): Promise<void> {
        for (const header of headerList) {
            if (header.keyName !== sortFeildHeader.keyName) {
                header.sortingOrder = '0';
            } else {
                if (header.sortingOrder === sortFeildHeader.sortingOrder) {
                    header.sortingOrder = '0';
                    sortFeildHeader.sortingOrder = '0';
                } else {
                    header.sortingOrder = sortFeildHeader.sortingOrder;
                }
            }
        }
        this.listQueryParams.sortingFeild = sortFeildHeader;
        this.processData(this.listpageData.listMaster, this.listQueryParams);
    }

    preNavagiateProcess(): Promise<any> {
        return new Promise((resolve, reject) => {
            // if (this.router.url.startsWith(NavigateRoutes.coBrandingLoading)) {
            //     return resolve(true);
            // }
            this.systemService.storageService
                .setStorage(this.router.url, {
                    pageData: this.listpageData,
                    pageMeta: this.listpageMeta,
                    componentData: this.listComponentData,
                    queryParams: this.listQueryParams,
                })
                .then((data) => {
                    this.systemService.storageService.pushKeysToStorage(this.router.url);
                    resolve(data);
                })
                .catch((error) => reject(error));
        });
    }

    navigatePage(route: any, dataRes: any = null) {
        this.preNavagiateProcess()
            .then((data) => {
                const message = this.routeMessage();
                message.transferData = dataRes.transferData;
                message.type = dataRes.type;
                this.systemService.routeByUrl(route, message).catch((error) => {
                    this.handleError(error, 'Base Veiw');
                });
            })
            .catch((error) => {
                this.handleError(error, 'BaseView');
            });
    }

    routeMessage(): RouteMessage {
        const message = new RouteMessage();
        message.type = RequestType.GET;
        return message;
    }

    addFieldValidation(fieldName: string, fieldProps: any) {
        const validationProps: { required?: boolean; type?: string; minLength?: number; maxLength?: number; pattern?: string; } = {
            required: fieldProps?.required,
            type: fieldProps?.type,
            maxLength: fieldProps?.maxlength,
            minLength: fieldProps?.minlength,
            pattern: fieldProps?.pattern,
        };
        const fieldControl = this.initializedListForm.get(fieldName);

        const Validation: ValidatorFn[] = [];
        if (!fieldControl) {
            return;
        }
        if (validationProps.required) {
            Validation.push(Validators.required);
        }
        if (validationProps.minLength) {
            Validation.push(Validators.minLength(validationProps.minLength));
        }
        if (validationProps.maxLength) {
            Validation.push(Validators.maxLength(validationProps.maxLength));
        }
        if (validationProps.pattern) {
            Validation.push(Validators.pattern(validationProps.pattern));
        }
        if (validationProps.type === 'url') {
            const pattern = formValidationCheck;
            Validation.push(Validators.pattern(pattern));
        }
        if (validationProps.type === 'email') {
            Validation.push(Validators.pattern(emailConstantRegex));
        }
        fieldControl.setValidators(Validation);
    }

    async onTransactionClose(event: boolean) {
        this.systemService.isTransactionRouteForPopup = false;
        this.systemService.showModal = false;
        this.systemService.dismissPopup();
        this.systemService.removeLocalStorage(StorageConstants.transactionRefNo);
        if (this.systemService.logOutClicked) {
            this.systemService.logOut();
            return;
        }
        let isExistUrl;
        isExistUrl = new TabInfoModel().tabInfo.filter((tabItem) => {
            return tabItem.routeTo === this.systemService.routerDetails.url;
        });

        this.sideMenuItems.forEach((item) => {
            if (item.url && item.url === this.systemService.routerDetails.url) {
                isExistUrl.push(this.systemService.routerDetails.url);
            } else {
                item.subItems.forEach((subItem) => {
                    if (subItem.url === this.systemService.routerDetails.url) {
                        isExistUrl.push(this.systemService.routerDetails.url);
                    }
                });
            }
        });
        if (isExistUrl.length > 0) {
            await this.systemService.storageService.clearStorage();
        }
        if (this.systemService.routerDetails.url === NavigateRoutes.selectInvestor) {
            this.systemService.storageService.getLastKeyAndDeletefromStorage();
        }

        this.systemService.routeByUrl(this.systemService.routerDetails.url, this.systemService.routerDetails.message);
    }

    closeModal(event: boolean) {
        if (this.systemService.showModal) {
            this.systemService.showModal = false;
        }

        if (this.listpageMeta.properties.unitAllotmentOpen) {
            this.listpageMeta.properties.unitAllotmentOpen = false;
        }

        this.systemService.dismissPopup();
    }
}
